module.exports = __webpack_public_path__ + "static/media/colorListen.895169a5.gif";